<template>
    <van-nav-bar fixed>
      <slot slot="left" name="left"></slot>
      <slot slot="title" name="title"></slot>
      <slot slot="right_side"></slot>
      <slot slot="right" name="right"></slot>
    </van-nav-bar>
</template>

<script>
import {NavBar} from 'vant';

export default {
  name: 'NavBar',
  components: {
    [NavBar.name]: NavBar,
  }
}
</script>

<style scoped>
</style>